<script setup>
import Popup from './popup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';

</script>

<script>

import * as oxygenUtil from "./SimpliaV2Components/OxygenUtil";

export default {
  components: {
    Popup,
  },
  data: () => ({
    popupshow: false,
    roles: [],
    roleTokens: {},
    role: "",
    passCode: "",
    viewport: "",
    clientId: "",
    client: null,
    clientContext: null,
  }),
  mounted() {

  },
  computed: {
  },
  methods: {
    checkCode: function () {
      console.log("switch Role");
      const token = this.roleTokens[this.client.ClientLeftRole][this.role];
      if (token === this.passCode) {
        window.BotServices.PullPE(
          {
            ByClientID: this.client.Client,
            InitialContext: {
              ByClientID: this.client.Client,
              viewPort: {
                width: '100vw'
              }
            },
            OpenPE: oxygenUtil.createSimpleOES(
              [this.client.ClientLeftRole, this.client.ClientLeft, this.role, this.client.ClientRight])
          }
        );

      }
      this.popupshow = false;
    },
    showPopUp: function (client, viewport, store) {
      console.log("====show pop up====" + this.popupshow);
      this.client = window.devStore.clients[0]
      this.clientContext = this.client ? JSON.parse(this.client.ClientContext) : {}
      this.getRoles().then((r) => {
        console.log('ALL ROLES', this.roles)
        this.popupshow = true;
      })
    },

    async getRoles() {
      let componentEdge = await oxygenUtil.getComponent(this.client.ClientLeft, this.client.ClientRight);
      this.roleTokens = componentEdge.RoleTokens;
      console.log('Role Tokens', this.roleTokens)
      const roles = await oxygenUtil.getAvailableComponentsRoles(
        [
          {
            id: this.client.ClientRight,
            defaultRole: this.client.ClientRightRole
          }
        ],
        this.clientContext.ToRightID,
        this.clientContext.ToRightR,
        [],
        []
      )
      this.roles = roles[this.client.ClientRight]
    }
  }
}
</script>

<template>
  <v-button style="display:none;" @click="show = true">Open modal</v-button>
  <Popup v-model="popupshow">
    <template v-slot:title>Switch Role</template>
    <template v-slot:content>
      <form class="formbox">
        <div class="form-group" style="display:flex;margin-top: 10px;">
          <span class="label-text">Role Name</span>
          <select type="text" name="selectRole" id="roleSelect" class="input-text" v-model="role">
            <option v-for="(r, i) in roles" :value="r.role" :key="i">{{r.role}}</option>
          </select>
        </div>
        <div class="form-group" style="display:flex;margin-top: 10px">
          <span class="label-text">Pass Code</span>
          <input type="password" name="passCode" id="rolePasscode" class="input-text" v-model="passCode" />
        </div>
      </form>
    </template>
    <template v-slot:action>
      <button type="button" class="ButtonText" @click="checkCode">Submit</button>
    </template>
  </Popup>
</template>

<style scoped>
.label-text {
  padding: 0 50px;
}

.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
  padding: 5px;
}

.ButtonText {
  margin-left: 145px;
  height: 25px;
  background-color: #0072c5;
  color: #fff;
  white-space: nowrap;
  align-items: center;
  width: 100%;
}

.formbox {
  border: 0px solid #2f2f2f;
  border-radius: 4px;
  font-family: Roboto, Arial, Tahoma, Verdana, sans-serif !important;
}
</style>
